<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        <v-icon large left>mdi-wrench-clock</v-icon>
                        <h6>Listado de Documentos y Planos</h6>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" md="4" sm="6">
                                Cliente: {{ cliente }}
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                Obra: {{ obra }}
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                Codificación: {{ codigo }}
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" md="4" sm="4">
                                Texto contenido: {{ descr }}
                            </v-col>
                            <v-col cols="12" md="3" sm="4">
                                Cantidad de Documentos: {{ listadoFiltrado.length }}
                            </v-col>
                            <v-col cols="12" md="2" sm="4">
                                <v-select dense outlined :items="listadotipo" item-text="tipodescripcion"
                                    item-value="tipoplano" label="Filtrar por tipo:" v-model="tipo" clearable
                                    hide-details="auto" class="font-class-name" />
                            </v-col>
                            <v-col cols="12" md="2" sm="4">
                                <v-select dense outlined :items="listadoestado" item-text="valor" item-value="texto"
                                    clearable label="Filtrar por estado:" v-model="estado" hide-details="auto"
                                    class="font-class-name" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-data-table dense :headers="headers" :items="listadoFiltrado" :single-expand="true" locale="es-ar"
                    class="elevation-1" :items-per-page="2000" hide-default-footer :loading="loadtable"
                    loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                    <template v-slot:item.nomplano="{ item }">
                        <div class="celda-color" :style="{ backgroundColor: row_color(item) }">
                            {{ item.nomplano }}
                        </div>
                    </template>
                    <template v-slot:item.estado="{ item }">
                        <div :style="{ color: text_color(item) }">
                            {{ item.estado }}
                        </div>
                    </template>
                    <template v-slot:item.archivootro="{ item }">
                        {{ item.archivootro }}.{{ item.tipoarchivo }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small class="mr-2" @click="editar(item)">
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-app>
        </div>
    </v-dialog>
</template>

<style scoped>
.font-class-name2 {
    font-size: 12px !important;
}

::v-deep .v-data-table .v-data-table__wrapper td {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

::v-deep .v-data-table .v-data-table-header tr th {
    font-size: 12px !important;
    padding: 2px 4px !important;
}

.celda-color {
    width: 100%;
    height: 100%;
    padding: 4px 8px;
    box-sizing: border-box;
}
</style>
<script>
import axios from "../../../axios-auth";
//import Ver from "../Documentos/Listadodoc.vue";
import moment from "moment";

export default {
    //   components: { Ver },
    data: (vm) => ({
        usuario: "",
        editedItem: {
            fact: "",
            codgral: "",
            empresa: "",
            codoc: "",
            responsable: "",
        },
        editedIndex: -1,
        listado: [],
        listadoestado: [
            { texto: "T", valor: "Con actividad" },
            { texto: "X", valor: "Sin actividad" },
            { texto: "A", valor: "Enviados" },
            { texto: "D", valor: "Aprobados" },
            { texto: "C", valor: "Aprobados c/obs" },
            { texto: "B", valor: "Observados" },
            { texto: "R", valor: "Recibidos (Apr, Apr c/obs, Obs)" },
        ],
        listadotipo: [],
        estado: "",
        tipo: "",
        showEditar: false,
        loadtable: false,
        headers: [
            {
                text: "Nombre",
                align: "start",
                sortable: false,
                value: "nomplano",
            },
            { text: "Revisión", value: "revision", sortable: false },
            { text: "Descripción", value: "descrplano", sortable: false },
            { text: "Archivo", value: "archivootro", sortable: false },
            { text: "N° OT", value: "orden", sortable: false },
            { text: "Proyectó", value: "nombreproyecto", sortable: false },
            { text: "Dibujó", value: "nombredibujo", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
            { text: "% de avance", value: "avance", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargarListados();
                    this.listadotipos();
                }

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
        listadoFiltrado() {
            return this.listado.filter(item => {

                /* =====================
                   FILTRO POR TIPO
                ====================== */
                if (this.tipo && item.tipoplano !== this.tipo) {
                    return false;
                }

                /* =====================
                   FILTRO POR ESTADO
                ====================== */
                if (!this.estado) return true;

                const estado = item.estado;

                switch (this.estado) {
                    case "T": // Con actividad
                        return estado !== null && estado !== "";

                    case "X": // Sin actividad
                        return estado === null || estado === "";

                    case "A": // Enviados
                        return estado === "A";

                    case "D": // Aprobados
                        return estado === "D";

                    case "C": // Aprobados c/obs
                        return estado === "C";

                    case "B": // Observados
                        return estado === "B";

                    case "R": // Recibidos (B, C, D)
                        return ["B", "C", "D"].includes(estado);

                    default:
                        return true;
                }
            });
        }

    },
    props: ["visible", "numcliente", "numobra", "proyectista", "descr", "avance", "cliente", "obra", "codigo"],

    methods: {
        text_color(item) {
            if (item.estado == "ENV") {
                return "#0000FF";
            }
            if (item.estado == "OBS") {
                return "#FF0000";
            }
            if (item.estado == "AcO") {
                return "#800080";
            }
            if (item.estado == "APR") {
                return "#008000";
            }
            else {
                return "#000000";
            }
        },

        row_color(item) {

            if (item.tipoplano == "E") {
                return "#FFCC99";
            }
            if (item.tipoplano == "C") {
                return "#FFFF99";
            }
            if (item.tipoplano == "M") {
                return "#99FF66";
            }
            if (item.tipoplano == "B") {
                return "#CC99FF";
            }
            if (item.tipoplano == "D") {
                return "#99FFCC";
            }
            if (item.tipoplano == "T") {
                return "#99CCFF";
            }
            if (item.tipoplano == "P") {
                return "#FF99FF";
            }
            if (item.tipoplano == "F") {
                return "#FFFF66";
            }
            if (item.tipoplano == "N") {
                return "#9999FF";
            }
            if (item.tipoplano == "X") {
                return "#FF9933";
            }
            if (item.tipoplano == "O") {
                return "#CCCCCC";
            }
            if (item.tipoplano == "AI") {
                return "#99FF99";
            }
            if (item.tipoplano == "PR") {
                return "#CCFF66";
            }
            if (item.tipoplano == "PT") {
                return "#CCFF66";
            }
            if (item.tipoplano == "A") {
                return "#CCCCFF";
            }
        },
        listadotipos() {
            let self = this;
            axios
                .get("/Ingenieria/Listadotipos?", {

                })
                .then((response) => {
                    self.listadotipo = response.data;
                })
                .catch((error) => {
                    self.listadotipo = [];
                    console.log(error);
                });
        },
        cargarListados() {
            this.loadtable = true;
            let self = this;
            axios
                .get("/Ingenieria/Listadoplanos?", {
                    params: {
                        numobra: self.numobra,
                        numcliente: self.numcliente,
                        avance: self.avance,
                        proyectista: self.proyectista,
                        descrplano: self.descr,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });

        },

        vaciarModels() {
            this.listado = [];

        },
    },
};
</script>
